module.exports = __webpack_public_path__ + "img/ic_search_home.c8529899.svg";